import iHedera from "assets/img/hedera-chain.png";
import iSolana from "assets/img/solana-chain.svg";
import { isEmpty } from 'lodash';
import { FC, useMemo } from 'react';
import { ChainId, Ido, getChainIconSrc } from 'sdk';

type PropsType = {
  project: Ido
}

const getProjectChainIds = (ido: Ido) => {
  return ido.claimCurrency?.filter(({ chainId }) => chainId).map(({ chainId }) => chainId);
};

const getChainIcon = (chainId: ChainId) => {
  return (
    <img
      key={`chain-icon-${chainId}`}
      src={getChainIconSrc(chainId)}
      style={{ width: 22, height: 22, marginLeft: 5 }}
      alt="chain"
    />
  );
};

const IdoClaimNetworksList: FC<PropsType> = ({ project }) => {

  const idoClaimChainIds = useMemo(() => {
    return getProjectChainIds(project)
  }, [project])

  if (project.claimType.toLowerCase() !== 'gagarin') {
    return (
      <>
        {project.claimType.toLowerCase() === "swords of blood" && (
          <img width={22} height={22} src={iSolana} alt="Solana" />
        )}
        {project.claimType.toLowerCase() === "hhmc" && (
          <img width={22} height={22} src={iSolana} alt="Solana" />
        )}
        {project.claimType.toLowerCase() === "astra nova" && (
          <img width={22} height={22} src={iHedera} alt="Hedera" />
        )}
      </>
    )
  }

  if (isEmpty(idoClaimChainIds)) {
    return <>TBA</>
  }

  return (
    <>
      {idoClaimChainIds?.map((chainId) => getChainIcon(chainId))}
    </>
  )
}

export default IdoClaimNetworksList
